// src/components/Login/ForceLogoutModal.jsx
import React, { useState, useEffect } from "react";
import { Modal, Button, message } from "antd";
import socket from "../../services/socket"; // ← importamos la instancia compartida
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import config from "../../config";
import { clearLogout } from "../../store/auth/authSlice";
import { persistor } from "../../store/auth/store";

export default function ForceLogoutModal() {
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.user?.token);

  // 1) Escucha eventos de logout forzado por admin vía WebSocket
  useEffect(() => {
    if (!token) return;

    // Identificamos este cliente en el canal "user-<oid>"
    socket.emit("identify", token);

    const onAdminLogout = () => {
      message.warning("Tu sesión ha sido cerrada por un administrador.", 3);
      setVisible(true);
    };
    socket.on("force-logout", onAdminLogout);

    return () => {
      socket.off("force-logout", onAdminLogout);
    };
  }, [token]);

  // 2) Escucha el evento global "force-logout" que dispara el interceptor al 401
  useEffect(() => {
    const onInterceptorLogout = () => {
      message.warning(
        "Tu sesión ya no es válida. Por favor, vuelve a iniciar sesión.",
        3
      );
      setVisible(true);
    };
    window.addEventListener("force-logout", onInterceptorLogout);
    return () => {
      window.removeEventListener("force-logout", onInterceptorLogout);
    };
  }, []);

  const handleConfirm = async () => {
    // Limpieza completa: cookie, redux, storage y redirección
    try {
      await axios.post(
        `${config.baseUrl}/api/auth/logout`,
        {},
        { withCredentials: true }
      );
    } catch {
      // ignora errores
    }
    await persistor.purge();
    dispatch(clearLogout());
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <Modal
      open={visible}
      title="Sesión finalizada"
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={[
        <Button key="ok" type="primary" onClick={handleConfirm}>
          Aceptar
        </Button>,
      ]}
    >
      <p>
        ¡Ups! Detectamos que tu sesión ya no es válida.
        <br />
        <strong style={{ color: "red" }}>Inicia sesión de nuevo.</strong>
      </p>
      <p>
        Tu sesión fue cerrada por seguridad (por ejemplo, expiró el token o
        iniciaste sesión en otro equipo).
      </p>
    </Modal>
  );
}
